var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\logo.png",
      "height": "40px",
      "width": "100px"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://bcbatam.beacukai.go.id/"
    }
  }, [_vm._v("KPU BC Batam")]), _vm._v(" © 2022. Versi 2.1.2\n")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cc949c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 133
// module chunks = 0